var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// Read more

$('.readmore').click(function (event) { 
  event.preventDefault();
  var descriptionFull = document.querySelector('.abz-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.abz-description-short'); 
  descriptionShort.style.display = 'none'; 
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.abz-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.abz-description-short');
  descriptionShort.style.display = 'block';
});


function initCustomProductForms() {
  let customProductForms = document.querySelectorAll('product-set form');
  if (!customProductForms || theme.settings.cartType !== 'dropdown') return;

  customProductForms.forEach(form => new theme.AjaxProduct(form, '.add-to-cart'));
}

initCustomProductForms();

class ProductSet extends HTMLElement {
  constructor() {
    super();

    this.variantSelector = this.querySelector('select[name="id"]');
    this.variantSelector && this.variantSelector.addEventListener('change', () => this.updateImage());
  }

  updateImage() {
    let firstImage = this.querySelector('.product-set-img img.first');
    firstImage && firstImage.classList.remove('first');

    let altTag = this.variantSelector.selectedOptions[0].title;
    this.querySelector(`.product-set-img img[alt="${altTag}"]`).classList.add('first');
  }
}

customElements.define('product-set', ProductSet);


// Brand images
$('.brand_img_slide').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 800,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

// simply slide
$('.simply_img_slide').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  variableWidth: true,
  autoplaySpeed: 5000,
  rows: 2,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});


// PDP Collection slider 
$('.feature_pdp').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 800,
  autoplaySpeed: 5000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



// People carousel
$('.people-carousel').slick({
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 10,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }]
});


// American carousel
$('.american-carousel').slick({
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 10,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0, 
  speed: 10000,
  cssEase: 'linear',
  pauseOnHover: false,
  pauseOnFocus: false,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 8
      }
    },
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 6
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});


// abz testi content
$('.abz_testi_content').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 800,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


// Aerformers carousel
$('.performers-carousel').slick({
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0, 
  speed: 10000,
  cssEase: 'linear',
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 8
      }
    },
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 6
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});



// Home page video section


document.addEventListener("DOMContentLoaded", function () {
  let currentPlayingVideo = null;

  document.querySelectorAll(".video-item").forEach((item) => {
    let video = item.querySelector("video");
    let playButton = item.querySelector(".play-button");

    item.addEventListener("click", function () {
      // If there's a video currently playing, pause it
      if (currentPlayingVideo && currentPlayingVideo !== video) {
        currentPlayingVideo.pause();
        currentPlayingVideo.closest('.video-item').classList.remove("playing");
      }
 
      // Now play the clicked video
      if (video.paused) {
        video.play();
        item.classList.add("playing");
        currentPlayingVideo = video;  // Update the currently playing video
      } else {
        video.pause();
        item.classList.remove("playing");
        currentPlayingVideo = null;  // Reset current playing video
      }
    });
  });
});


// // sticky button
document.addEventListener("DOMContentLoaded", function () {
  var abzBtn = document.getElementById("AbzCustomBtn");
  let formAtc = document.querySelector("[data-product-blocks] form [data-add-to-cart]");

  if (!abzBtn || !formAtc) return;

  // Create Intersection Observer
  const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Element is visible - hide custom button
      abzBtn.style.display = "none";
    } else {
      // Element is not visible - show custom button
      abzBtn.style.display = "block";
    }
  });
  }, {
  threshold: 0,
  rootMargin: '0px'
  });

  // Observe each form element
  observer.observe(formAtc);

  function handleSticky() {
    // if (window.innerWidth <= 767) {
    //   var scrollTop = window.scrollY || window.pageYOffset;

    //   if (scrollTop >= 200) {
    //     abzBtn.classList.add("sticky");
    //   } else {
    //     abzBtn.classList.remove("sticky");
    //   }
    // } else {
    //   // Remove sticky class if screen is larger than 767px
    //   abzBtn.classList.remove("sticky");
    // }
  }

  // window.addEventListener("scroll", handleSticky);
  // window.addEventListener("resize", handleSticky);

  // handleSticky(); // Run on load
});
